// libraries
import styled from "styled-components";
import { flexSmart, RemoveScrollbar } from "@caps-mobile/styled-lib";
import { BORDER_RADIUS } from "~/constants";
import { EThemeOptions } from "~/theme";

export const MapModalWrapper = styled.div`
    position: absolute;

    width: 1000px;
    height: 675px;

    border-radius: ${BORDER_RADIUS}px;

    overflow: hidden;

    ${RemoveScrollbar}

    background-color: ${props => props.theme.colors["bg-primary"].rgba};
`;

export const StyledMapModal = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    border-radius: ${BORDER_RADIUS}px;
`;

export const buttonWrapper = styled.div`
    width: 100%;
    ${flexSmart("space-between center")}
`;

export const xIconWrapper = styled.div`
    padding: 10px;
    ${flexSmart("center center")}
    border-radius: 10px;
    background: rgba(30, 30, 30, 0.5);

    ${props => props.theme.mode === EThemeOptions.Dark
        ? `background-color: ${props.theme.colors["bg-primary"].rgba};`
        : `background-color: rgba(30, 30, 30, 0.5);`
    }

    :hover{
        cursor: pointer;
    }
`;

export const Header = styled.div`
    width: 100%;

    ${flexSmart("center center")}

    font-weight: 600;
    font-size: 32px;
    line-height: 36px;

    color: ${props => props.theme.colors["text-primary"].rgba};

    text-align: center;
    padding-bottom: 10px;
`;

export const DetailRow = styled.div`
    height: auto;
    width: 100%;
`;

export const CameraGroupWrapper = styled.div`
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: ${BORDER_RADIUS}px;

    overflow: hidden;

    background-color: ${props => props.theme.colors["bg-primary"].rgba};
`;